import React, { memo, useRef } from 'react'
import usePageProps from 'hooks/usePageProps'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import { useRouter } from 'next/router'
import { toggleValueFromString } from 'utils/universal'
import { parseFiltersToUrl } from 'filters'
import Draggable from 'components/Draggable'
import useMediaQuery from '@mui/material/useMediaQuery'
import sx from './styles'

const StateFilter = () => {
  const { states } = usePageProps()
  const router = useRouter()
  const { formatMessage: f } = useIntl()
  const dragRef = useRef(null)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const blogPath = f({ id: 'BLOG_ROUTE' })

  const handleClick = (state) => {
    const newStateValue = toggleValueFromString(router?.query?.estados, `${state}`)
    const paramsUrl = parseFiltersToUrl({ states: newStateValue })
    router.push(`${blogPath}${paramsUrl}`, null, { shallow: true })
  }

  const statesList = (
    states?.map((state) => (
      <Box>
        <Button
          sx={sx.button}
          variant="default"
          onClick={() => handleClick(state?.slug)}
          className={clsx('slim', {
            selected: router?.query?.estados?.includes(state?.slug),
          })}
        >
          {state?.name}
        </Button>
      </Box>
    ))
  )

  const draggableStates = (
    <Draggable innerRef={dragRef}>
      <Box
        marginTop={1}
        sx={sx.draggableContainer}
      >
        {statesList}
      </Box>
    </Draggable>
  )

  return (
    <Grid container>
      <Grid
        item
        xs={12}
      >
        <Box>
          <Typography variant="h4">
            <FormattedMessage id="STATES" />
            :
          </Typography>
        </Box>

      </Grid>
      <Grid
        item
        xs={12}
        mt={1}
        sx={!isMobile && sx.states}
      >
        {isMobile ? draggableStates : statesList}
      </Grid>
    </Grid>
  )
}

export default memo(StateFilter)
